__turbopack_context__.v({
  "OfficeHeroBackdrop": "OfficeHero-module-scss-module__DwHczW__OfficeHeroBackdrop",
  "OfficeHeroContent": "OfficeHero-module-scss-module__DwHczW__OfficeHeroContent",
  "OfficeHeroLogo": "OfficeHero-module-scss-module__DwHczW__OfficeHeroLogo",
  "OfficeHeroMedia": "OfficeHero-module-scss-module__DwHczW__OfficeHeroMedia",
  "OfficeHeroMediaParallax": "OfficeHero-module-scss-module__DwHczW__OfficeHeroMediaParallax",
  "OfficeHeroTitle": "OfficeHero-module-scss-module__DwHczW__OfficeHeroTitle",
  "OfficeHeroVideo": "OfficeHero-module-scss-module__DwHczW__OfficeHeroVideo",
});
